import React from 'react';

const fieldClass =
  'w-full h-10 px-3 text-sm text-prodia-text-primary bg-prodia-surface border border-prodia-border rounded-lg placeholder:text-prodia-text-muted focus:outline-none focus:ring-2 focus:ring-prodia-primary/30 focus:border-prodia-primary disabled:opacity-50 disabled:bg-prodia-background';

export function Input({ label, error, className = '', id, ...props }) {
  const inputId = id || (label ? `input-${label}` : undefined);
  return (
    <div className={className}>
      {label && (
        <label htmlFor={inputId} className="block text-xs font-medium text-prodia-text-secondary mb-1.5">
          {label}
        </label>
      )}
      <input id={inputId} className={`${fieldClass} ${error ? 'border-danger focus:ring-danger/30' : ''}`} {...props} />
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
}

export function Select({ label, error, className = '', children, id, ...props }) {
  const selectId = id || (label ? `select-${label}` : undefined);
  return (
    <div className={className}>
      {label && (
        <label htmlFor={selectId} className="block text-xs font-medium text-prodia-text-secondary mb-1.5">
          {label}
        </label>
      )}
      <select
        id={selectId}
        className={`${fieldClass} ${error ? 'border-danger focus:ring-danger/30' : ''}`}
        {...props}
      >
        {children}
      </select>
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
}

export function Textarea({ label, error, className = '', id, rows = 3, ...props }) {
  const textareaId = id || (label ? `textarea-${label}` : undefined);
  return (
    <div className={className}>
      {label && (
        <label htmlFor={textareaId} className="block text-xs font-medium text-prodia-text-secondary mb-1.5">
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        rows={rows}
        className={`w-full px-3 py-2 text-sm text-prodia-text-primary bg-prodia-surface border border-prodia-border rounded-lg placeholder:text-prodia-text-muted focus:outline-none focus:ring-2 focus:ring-prodia-primary/30 focus:border-prodia-primary disabled:opacity-50 ${error ? 'border-danger' : ''}`}
        {...props}
      />
      {error && <p className="mt-1 text-xs text-danger">{error}</p>}
    </div>
  );
}

export default Input;
